import { AutogenModelEdiShipmatchCrit, AutogenRowEdiShipmatchCrit } from "./autogen/AutogenModelEdiShipmatchCrit";

export class ModelEdiShipmatchCrit extends AutogenModelEdiShipmatchCrit<RowEdiShipmatchCrit> {
	constructor() {
		super(RowEdiShipmatchCrit);
	}
}

export class RowEdiShipmatchCrit extends AutogenRowEdiShipmatchCrit {
}